export class SecurityInfoResultDto {
    access: string[];
    roles: string[];
    departments: string[];
    users: string[];
    credentials: string[];
    securityIndicator: string;
}
